import NightAuditPage from './NightAuditPage';

export default NightAuditPage;
